import React from 'react';
import Tabbar from 'Components/Tabbar';
import EkiContentRenderer from 'Components/EkiContentRenderer';
import styles from './styles.scss';
import cn from 'classnames';
import { withUrlParams } from 'Utils/withUrlParams';
import { withRouter } from 'react-router-dom';
import Typography from 'Components/Typography';

class Highlights extends React.Component {
  state = {};
  footnotes = 0;

  constructor(props) {
    super(props);

    if (!props.highlightElements || !props.highlightElements.length) {
      return;
    }

    let initialTabIndex = 0;
    const { hash } = this.props.history.location;
    if (hash && hash.indexOf('highlights-') > -1) {
      const tabIndex = Number(hash.split('-').pop() - 1);
      initialTabIndex =
        !Number.isNaN(tabIndex) && props.highlightElements[tabIndex] ? tabIndex : initialTabIndex;
    }

    this.state = {
      initialTabIndex,
      highlights: props.highlightElements.reduce((acc, cur) => {
        if (cur.hidden) return acc;

        return [...acc, { ...cur, content: cur.content.filter((item) => !item.hidden) }];
      }, []),
      activeTabFromUrl: parseInt(this.props.urlParams.activetab, 10),
      scrolledToDeeplikId: false,
    };
  }

  containerRef = null;

  onTabChange = (index) => {
    const { highlightElements, setSharedState } = this.props;
    const highlightElement = highlightElements[index];

    if (highlightElement && highlightElement.formModelValue) {
      setSharedState('carModel', highlightElement.formModelValue);
    }
  };

  handleScroll = () => {
    this.containerRef.scrollIntoView({ behavior: 'smooth' });
  };

  componentDidMount() {
    const { initialTabIndex } = this.state;
    // initially trigger global carModel handling
    this.onTabChange(initialTabIndex);
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.urlParams || !this.props.urlParams) {
      return;
    }

    if (prevProps.urlParams.deeplinkid !== this.props.urlParams.deeplinkid) {
      setTimeout(() => {
        this.props.scrollToDeeplinkId();
      }, 300);
      this.setState({ scrolledToDeeplikId: true });
    }

    if (prevProps.urlParams.activetab !== this.props.urlParams.activetab) {
      this.setState({
        activeTabFromUrl: parseInt(this.props.urlParams.activetab, 10),
      });
    }
  }

  setRef = (ref) => {
    ref && (this.containerRef = ref);
  };

  renderHighlights = () => {
    const { background = 'white' } = this.props;
    const { highlights: highlightElements } = this.state;

    return highlightElements.map(({ content, title }, index) => (
      <div
        key={`${title}-${index}`}
        className={cn(styles.tabContent, {
          [background]: true,
        })}
      >
        <EkiContentRenderer
          content={content}
          preventScrollToDeeplikId={this.state.scrolledToDeeplikId}
          {...this.props}
        />
      </div>
    ));
  };

  rerenderCheck = ({ props: { prev, next } }) =>
    !!prev.sharedState.footnotes_landingpage &&
    !!next.sharedState.footnotes_landingpage &&
    prev.sharedState.footnotes_landingpage.length !== next.sharedState.footnotes_landingpage.length;

  render() {
    const {
      background = 'white',
      deeplinkId,
      headline,
      sharedState,
      updateOneUrlQuery,
    } = this.props;
    const { activeTabFromUrl, highlights, initialTabIndex } = this.state;
    const currentIndex =
      activeTabFromUrl && activeTabFromUrl < highlights.length ? activeTabFromUrl : initialTabIndex;

    if (!highlights || highlights?.length === 0) {
      return null;
    }

    return (
      <div
        className={cn(styles.root, {
          [background]: true,
          [styles.resetSpace]: highlights.length < 2,
        })}
        id={deeplinkId}
        ref={this.setRef}
      >
        {highlights.length > 1 ? (
          <>
            {headline && (
              <Typography.Headline className={styles.headline} {...headline} levelVisually={'h3'} />
            )}
            <Tabbar
              background={background}
              defaultIndex={currentIndex}
              id="hi-lp-highlights"
              onChange={this.onTabChange}
              rerenderCheck={this.rerenderCheck}
              rerenderMode="custom"
              sharedState={sharedState}
              tabs={highlights.map((el) => el.title)}
              updateOneUrlQuery={updateOneUrlQuery}
            >
              {this.renderHighlights()}
            </Tabbar>
          </>
        ) : (
          this.renderHighlights()
        )}
      </div>
    );
  }
}

export default withRouter(withUrlParams(Highlights));

Highlights.defaultProps = {
  highlightElements: [],
  headline: {
    level: 'h2',
    forceUppercase: true,
    value: 'Wählen Sie Ihre Kategorie aus',
  },
};
